module.exports = __webpack_public_path__ + "img/fruit-strawberries-190x100.8267f48f.jpg";